module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('group', [_c('cell', {
    attrs: {
      "value-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#4f5b77"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cuIndex) + "."), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.judge.subjectName)
    }
  }), _vm._v(" "), _c('span', [_vm._v("（判断"), (_vm.judge.score !== '' && _vm.judge.score !== undefined && _vm.judge.score !== 0) ? _c('span', {}, [_vm._v("， " + _vm._s(_vm.judge.score) + "分")]) : _vm._e(), _vm._v("）")])])])], 1), _vm._v(" "), _c('checklist', {
    ref: _vm.judge.id,
    attrs: {
      "max": 1,
      "options": _vm.options
    },
    on: {
      "on-change": _vm.toggleOption
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bfa8c9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/Judgement/index.vue
// module id = 5rG+
// module chunks = 7